import { rei } from "@/services/api"

class SepultamentoSugestaoService {
  static getSepultamentoSugestao (params) {
    const query = []

    params.nome && query.push('nome=' + params.nome)
    params.page && query.push('page=' + params.page)
    params.perPage && query.push('perPage=' + params.perPage)
    params.cartorio_id && query.push('cartorio_id=' + params.cartorio_id)

    return rei.get(`sepultamento-sugestao?${query.join('&')}`).then(res => res.data)
  }

  static storeSepultamentoSugestao (sepultamentoSugestao) {
    return rei.post(`sepultamento-sugestao`, sepultamentoSugestao).then(res => res.data)
  }

  static updateSepultamentoSugestao (sepultamentoSugestao, id) {
    return rei.put(`sepultamento-sugestao/${id}`, sepultamentoSugestao).then(res => res.data)
  }

  static destroySepultamentoSugestao (id) {
    return rei.delete(`sepultamento-sugestao/${id}`)
  }
}

export default SepultamentoSugestaoService
